import React, { memo, useEffect, useState } from "react";
import "./MarketSummaryPdf.css";
import { Config } from "../../../../Utils/Config";
import { useNavigate, useLocation } from "react-router-dom";
import Paper from "@mui/material/Paper";
import { TableBody, TableContainer, TableHead, Table, TableCell, TableRow } from "@mui/material";
import { updateObjectValues } from "../../../../helpers/dataHelper";
let summary;

const MarketSummaryPdf = memo((props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [marketSummary, setMarketSummary] = useState({});

  useEffect(() => {
    if (props && props.data) {
      setMarketSummary({ ...marketSummary, marketSummary: props.data });
    }
  }, [props && props.data])


  //get parks summary details
  const getSummaryDetails = () => {
    summary = [];
    let summaryDetails = updateObjectValues(marketSummary.marketSummary.summaryformarket);
    let summaryFor50Miles = updateObjectValues(marketSummary.marketSummary.summaryfor50miles) || null;
    let summaryfor100miles = updateObjectValues(marketSummary.marketSummary.summaryfor100miles) || null;
    let summaryForNational = updateObjectValues(marketSummary.marketSummary.summaryfornational);

    const excludedKeys = new Set([
      "rvparkids",
      "caucasian",
      "black",
      "hispanic",
      "others",
      "avgmaleinmarket",
      "avgfemaleinmarket",
      "asianpacific",
      "marketdemandformarket",
      "marketdemandfornational",
      "demandsupplyratiofornational",
      "percentageofhousehold",
      "avgfuelcost",
      "rvparkdemandscorefornational",
      "rvparkdemandscoreformarket"
    ]);

    for (let i = 0; i < Object.keys(summaryDetails).length; i++) {

      const key = Object.keys(summaryDetails)[i].toLowerCase();  // Lowercase key to handle case insensitivity
      const value = Object.values(summaryForNational)[i];      
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        value !== 0 &&
        !excludedKeys.has(key)  // Check if the key is in the excluded keys set
      ) {
        
        const tableHeaderMap = {
          rvparksinmarket: "RV Parks in market",
          totalrvparksites: "Total Camping spots",
          avgpricepernight: "Average price per night",
          countofhousehold: "Households",
          marketdemandformarket: "Market Demand For Market",
          marketdemandfornational: "Market Demand For National",
          demandsupplyratioformarket: "Demand Supply Ratio",
          demandsupplyrationational: "Demand Supply Ratio For National",
          rvparkdemandscoreformarket: "RV Park Demand Score For Market",
          rvparkdemandscorefornational: "RV Park Demand Score For National",
          potentialcampers: "Potential Campers based on Demand",
          avgsizeofpark: "Average Size Of Park",
          rvownershipinmarket: "RV Ownership in market",
          percentageofhousehold: "% Of Households that camp",
          population: "Population",
          populationdensity: "Population Density(per sq mi)",
          regiontype: "Region Type",
          incomepercapita: "Income per capita",
          avgfuelcost: "Average Fuel Cost",
          avgage: "Average Age",
          fivetotwentyfour: "Population age from 5-24",
          twentyfivetofortyfour: "Population age from 25-44",
          fortyfivetofiftyfour: "Population age from 45-54",          	
          fiftyfivetoseventyfour: "Population age from 55-74",
          seventyfiveandabove: "Population age of 75 And Above"
        };

        // Access the key and convert it to lowercase for case-insensitive matching
        const key = Object.keys(summaryDetails)[i].toLowerCase();

        // Use the map to fetch the corresponding table header, or default to the key if not found
        let tableHeader = tableHeaderMap[key] || key; 

        let formatValue = Object.values(summaryDetails)[i];
        let headerValue =
          (Object.keys(summaryDetails)[i] === "avgfuelcost" ||
            Object.keys(summaryDetails)[i] === "avgpricepernight" ||
            Object.keys(summaryDetails)[i] === "incomepercapita") && formatValue !== '-'
            ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? Config.Currency + formatValue: formatValue
            : Object.keys(summaryDetails)[i] === "avgsizeofpark" && formatValue !== '-'
              ? formatValue + " Acres"
              : (Object.keys(summaryDetails)[i] === "percentageofhousehold" ||
                Object.keys(summaryDetails)[i] === "avgmaleinMarket" ||
                Object.keys(summaryDetails)[i] === "avgfemaleinmarket") && formatValue !== '-'
                ? formatValue + "%"
                : formatValue;

                let headerValue2 = "";
                if(summaryFor50Miles){
                  formatValue = Object.values(summaryFor50Miles)[i];
                  headerValue2 = (Object.keys(summaryFor50Miles)[i] === "avgfuelcost" ||  Object.keys(summaryFor50Miles)[i] === "avgpricepernight" || Object.keys(summaryFor50Miles)[i] === "incomepercapita") && formatValue !== '-'
                  ? Config.Currency + formatValue
                  : Object.keys(summaryFor50Miles)[i] === "avgsizeofpark" && formatValue !== '-'
                  ? formatValue + " Acres"
                  : (Object.keys(summaryFor50Miles)[i] === "percentageofhousehold" ||
                  Object.keys(summaryFor50Miles)[i] === "avgmaleinMarket" ||
                  Object.keys(summaryFor50Miles)[i] === "avgfemaleinmarket") && formatValue !== '-'
                  ? formatValue + "%"
                  : formatValue;
                }

                let headerValue3 = "";
                if(summaryfor100miles){
                  formatValue = Object.values(summaryfor100miles)[i];
                  headerValue3 =
                    (Object.keys(summaryfor100miles)[i] === "avgfuelcost" ||
                      Object.keys(summaryfor100miles)[i] === "avgpricepernight" ||
                      Object.keys(summaryfor100miles)[i] === "incomepercapita") && formatValue !== '-'
                      ? Config.Currency + formatValue
                      : Object.keys(summaryfor100miles)[i] === "avgsizeofpark" && formatValue !== '-'
                        ? formatValue + " Acres"
                        : (Object.keys(summaryfor100miles)[i] === "percentageofhousehold" ||
                          Object.keys(summaryfor100miles)[i] === "avgmaleinMarket" ||
                          Object.keys(summaryfor100miles)[i] === "avgfemaleinmarket") && formatValue !== '-'
                          ? formatValue + "%"
                          : formatValue;

                }



        formatValue = Object.values(summaryForNational)[i];
        let headerValue4 =
          (Object.keys(summaryForNational)[i] === "avgfuelcost" ||
            Object.keys(summaryForNational)[i] === "avgpricepernight" ||
            Object.keys(summaryForNational)[i] === "incomepercapita") && formatValue !== '-'
            ? Config.Currency + formatValue
            : Object.keys(summaryForNational)[i] === "avgsizeofpark" && formatValue !== '-'
              ? formatValue + " Acres"
              : (Object.keys(summaryForNational)[i] === "percentageofhousehold" ||
                Object.keys(summaryForNational)[i] === "avgmaleinMarket" ||
                Object.keys(summaryForNational)[i] === "avgfemaleinmarket") && formatValue !== '-'
                ? formatValue + "%"
                : formatValue;
        summary.push(

          <TableRow key={Object.keys}>
            <TableCell>{tableHeader === "Demand Supply Ratio"
              ?
              <>Demand Supply Ratio<br />
                <span className="small-info">(Number of Campers per Camping Spots.)</span>
              </>
              :
              tableHeader}</TableCell>
            <TableCell>{headerValue}</TableCell>
            {summaryFor50Miles &&  <TableCell>{headerValue2}</TableCell> }
            {summaryfor100miles &&  <TableCell>{headerValue3}</TableCell> } 
            <TableCell>{Object.keys(summaryForNational)[i] === "regiontype" ? "-" : headerValue4}</TableCell>
          </TableRow>

        );
      }
    }
    return summary;
  };


  let summaryFor50MilesBool = updateObjectValues(marketSummary?.marketSummary?.summaryfor50miles) || null;
  let summaryfor100milesBool = updateObjectValues(marketSummary?.marketSummary?.summaryfor100miles) || null;
  return (
    <div>
      <div className="common-table dashboard-summary">
        <TableContainer component={Paper} className="table-design">
          <Table sx={{ minWidth: 650 }} aria-label="simple table" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>This Market</TableCell>
                {summaryFor50MilesBool &&  <TableCell>Market at 50 Miles</TableCell> }
                {summaryfor100milesBool &&  <TableCell>Market at 100 Miles</TableCell> } 
                <TableCell>National</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {marketSummary && marketSummary.marketSummary && getSummaryDetails()}
              {marketSummary && marketSummary.marketSummary && marketSummary.marketSummary.length === 0 ? (
                <TableRow>
                  <TableCell
                    style={{ textAlign: "center" }}
                    className="store-no-data"
                  >
                    No Data Available
                  </TableCell>
                </TableRow>) : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
});

export default MarketSummaryPdf;
